import {Entity} from '@s-ui/domain'

export default class ModelEntity extends Entity {
  /**
   * @param {Object} model
   * @param {String} model.bodyType
   * @param {Number} model.doors
   * @param {String} model.id
   * @param {String} model.image
   * @param {String} model.make
   * @param {String} model.name
   * @param {String} model.slug
   * @param {String} model.url
   * */
}
